import licenseModule from '../../license.module';

export default licenseModule.component('licenseNewServer', {
    template: require('./licenseNewServer.component.html'),
    controller: ['$timeout', licenseNewServerComponent],
    bindings: {
        licenseEula: '<',
        licenseServerPayload: '<',
        licenseServerProfileError: '<',
        callback: '&'
    }
});

function licenseNewServerComponent($timeout) {
    var vm = this;
    vm.$onChanges = changeObject;

    function changeObject(changeObj) {
        if (
            changeObj.licenseServerProfileError != undefined &&
            changeObj.licenseServerProfileError.currentValue &&
            changeObj.licenseServerProfileError.currentValue != null &&
            changeObj.licenseServerProfileError.currentValue != undefined
        ) {
            vm.serverProfileError =
                changeObj.licenseServerProfileError.currentValue;
        }
    }

    vm.changes = function() {
        $timeout(function() {
            vm.licenseServerPayload = vm.licenseServerPayload.trim();

            // Check beginning and ending of the server profile string format
            vm.substringBegin = vm.licenseServerPayload
                .trim()
                .startsWith('----- BEGIN APPSPACE SERVER PROFILE -----');
            vm.substringEnd = vm.licenseServerPayload
                .trim()
                .endsWith('----- END APPSPACE SERVER PROFILE -----');

            if (vm.substringBegin == true && vm.substringEnd == true) {
                vm.serverProfileError = false;
            } else {
                vm.serverProfileError = true;
            }

            var value = {
                payload: vm.licenseServerPayload,
                eula: vm.licenseEula,
                serverProfileError: vm.serverProfileError
            };
            vm.callback({ value: value });
        });
    };

    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function(searchString, position) {
            var subjectString = this.toString();
            if (
                typeof position !== 'number' ||
                !isFinite(position) ||
                Math.floor(position) !== position ||
                position > subjectString.length
            ) {
                position = subjectString.length;
            }
            position -= searchString.length;
            var lastIndex = subjectString.lastIndexOf(searchString, position);
            return lastIndex !== -1 && lastIndex === position;
        };
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-new-server/licenseNewServer.component.js